/**
 * TaskApprovalPage - Task approval workflow dashboard
 *
 * Surfaces the TaskApprovalDashboard from @ferp/workflow-forms for admin/architect users.
 * Provides task approval workflows, SLA tracking, and approval chain visualization.
 *
 * Route: /admin/task-approval
 */

import { Container, Title, Group, Badge, Text, ThemeIcon } from '@mantine/core';
import { IconListCheck } from '@tabler/icons-react';

import { TaskApprovalDashboard } from '@ferp/workflow-forms';
import { useAuth } from '@/auth/AuthContext';

export function TaskApprovalPage() {
  const { tenant } = useAuth();

  return (
    <Container size="xl" py="md">
      <Group justify="space-between" mb="lg">
        <Group gap="sm">
          <ThemeIcon size="lg" variant="light" color="green">
            <IconListCheck size={20} />
          </ThemeIcon>
          <div>
            <Title order={3}>Task Approval</Title>
            <Text size="sm" c="dimmed">
              Task approval workflows, SLA tracking, and approval chain management
            </Text>
          </div>
        </Group>
        {tenant && (
          <Badge variant="light" color="gray">
            {tenant.name}
          </Badge>
        )}
      </Group>

      <TaskApprovalDashboard tenantId={tenant?.id ?? ''} />
    </Container>
  );
}

export default TaskApprovalPage;
